<template>
  <div class="shop-big-box">
    <ax-header :isShowSearch="false"></ax-header>
    <div class="shop-box">
      <div class="shop-name">
        <div class="logo"><img src="../../assets/logo.png" alt=""></div>
        <div class="explain-box" @mouseenter="mouseenterFun" @mouseleave="mouseleaveFun">
          <div class="title">洪伟的专卖店</div>
          <div class="explain">
            <p><span>描述</span><span class="red">5分</span></p>
            <p><span>服务</span><span class="red">5分</span></p>
            <p><span>物流</span><span class="red">5分</span></p>
          </div>
          <div class="detail-explain" v-show="isShowExplain">
            <div class="lable">
              <span>洪伟的专卖店</span>
            </div>
            <div class="score">
              <span>综合评分：5分</span>
            </div>
            <div class="shop-score">
              <p>店铺评分：</p>
              <ul>
                <li><span>描述相符：5分</span></li>
                <li><span>服务态度：5分</span></li>
                <li><span>发货速度：5分</span></li>
              </ul>
            </div>
            <div class="describe">
              <p><span>公司名称：</span><span>洪伟的专卖店</span></p>
              <p><span>所在地：</span><span>上海市杨浦区</span></p>
              <p><span>营业执照：</span><span>正常</span></p>
            </div>
            <div class="shop-btn">
              <el-button type="text" @click="gotoShop">进入店铺</el-button>
            </div>
          </div>
        </div>
        <div class="search-box">
          <el-input class="input-round" placeholder="请输入关键词" prefix-icon="el-icon-full-screen">
              <el-button slot="append" style="background: #f40000;color: #fff;border-radius: 0;height: 40px">搜索</el-button>
          </el-input>
        </div>
      </div>
      <div class="baner-box">
        <div class="baner-name">
          <el-carousel height="400px">
            <el-carousel-item v-for="(item, index) in bannerList" :key="index">
              <img style="width: 1200px;height: 400px;" :src="item.Url" alt="">
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>
      <div class="main-content">
        <div class="goods-list">
          <ax-goods class="goods-box" v-for="(item, index) in goodsList" :key="index" :goodsData="item"></ax-goods>
        </div>
      </div>
    </div>
    <ax-footer></ax-footer>
  </div>
</template>
<script>
import axheader from '../../components/AXheader.vue'
import axfooter from '../../components/AXfooter.vue'
import {
  GetRecommendBannerlist,
  BusinessNaviSpuList
} from '../../api/api'
export default {
  components: {
    'ax-header': axheader,
    'ax-footer': axfooter
  },
  data(){
    return{
      bannerList: [],
      goodsList: [],
      isShowExplain: false
    }
  },
  created(){
    this.getBanner()
    this.getBusinessNaviSpuList()
  },
  methods:{
    gotoShop(){
      this.$router.push('/shop')
    },
    mouseenterFun(){
      this.isShowExplain = true
    },
    mouseleaveFun(){
      this.isShowExplain = false
    },
    getBanner(){
      let params = {
        keyId: 'Banner'
      }
      GetRecommendBannerlist(params).then(res => {
        if(res.data.success){
          this.bannerList = res.data.response.Banners || []
        } else{
          this.$message.error(res.data.msg)
        }
      })
    },
    getBusinessNaviSpuList(){
      let params = {
        // naviId: 1,
        // typeId: 1,
        sortBy: 0,
        pageIndex: 1,
        pageSize: 40
      }
      BusinessNaviSpuList(params).then(res => {
        if(res.data.success){
          this.goodsList = res.data.response.data || []
        } else{
          this.$message.error(res.data.msg)
        }
      })
    },
  }
}
</script>
<style lang="scss" scoped>
.baner-name{
  width: 1200px;
  margin: 0 auto;
}
.shop-box{
  width: 1200px;
  margin: 0 auto;
}
.goods-list{
  width: 1200px;
  margin: 0 auto;
  display: flex;
  // justify-content: space-between;
  flex-wrap: wrap;
  padding: 20px 0;
  .goods-box{
    margin-bottom: 16px;
    margin-right: 16px;
  }
  .goods-box:nth-child(4n){
    margin-right: 0;
  }
}
.shop-name{
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  .logo{
    width: 191px;
    height: 75px;
    img{
      width: 100%;
      height: 100%;
    }
  }
  .explain-box{
    display: flex;
    width: 500px;
    padding: 0 10px;
    border-left: 1px solid #e1e1e1;
    position: relative;
    .title{
      margin-right: 20px;
      font-size: 14px;
      font-weight: bold;
      max-width: 200px;
      text-align: left;
      word-wrap: break-word;
      word-break: normal;
    }
    .explain{
      display: flex;
      padding-right: 10px;
      border-right: 1px solid #e1e1e1;
      span{
        display: block;
        margin-right: 5px;
      }
      .red{
        color: #f40000;
      }
    }
    .detail-explain{
      text-align: left;
      max-width: 310px;
      min-width: 200px;
      font-size: 14px;
      line-height: 24px;
      border: 1px solid #E1E1E1;
      position: absolute;
      background: #fff;
      top: 50px;
      // right: 0;
      z-index: 20;
      .lable{
        border-bottom: 1px solid #E1E1E1;
        padding: 10px;
        font-weight: bold;
      }
      .score{
        border-bottom: 1px solid #E1E1E1;
        padding: 10px;
      }
      .shop-score{
        border-bottom: 1px solid #E1E1E1;
        padding: 10px;
        >p{
          margin-bottom: 10px;
        }
      }
      .describe{
        border-bottom: 1px solid #E1E1E1;
        padding: 10px;
      }
      .shop-btn{
        padding: 10px;
        text-align: center;
      }
    }
  }
  .search-box{
    
  }
}
.el-input{
  width: 400px;
}
.input-round /deep/ .el-input__inner{ 
  border-color: #f40000; 
  border-radius: 0;
  &:focus{
    outline: none;
  }
}
</style>